import { useMutation } from "react-query";
import { deactivateRoles } from "../../../../../actions/Utilities/ModuleManagement";

const useDeactivateRoles = () => {
  return useMutation(deactivateRoles);
};
export default useDeactivateRoles;
